import React, { useState } from "react";

import TextField from "@material-ui/core/TextField";

import { DropzoneArea } from "material-ui-dropzone";
import { GENERAL_URL_API } from "../../../../shared/urls";
import swal from "sweetalert";
import { CloseRounded } from "@material-ui/icons";
import { CheckRounded } from "@material-ui/icons";
import { Button } from "@material-ui/core";

const CHUNK_THRESHOLD = 100 * 1024 * 1024; // 100MB — límite típico de Cloudflare
const CHUNK_SIZE = 80 * 1024 * 1024; // 80MB por chunk para margen de seguridad

const EditarArchivosLibro = ({ book, cancelFn }) => {
  const [loading, setLoading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(null);

  const [artState, setArtState] = useState({
    portada: {
      images: [],
      error: false,
    },
    screen1: {
      images: [],
      error: false,
    },
    screen2: {
      images: [],
      error: false,
    },
    screen3: {
      images: [],
      error: false,
    },
  });

  const [contentState, setContentState] = useState({
    images: [],
    error: false,
  });

  const handleDropFileChange = (images, type, artName) => {
    if (type === "art")
      setArtState({
        ...artState,
        [artName]: {
          ...artState[artName],
          images,
        },
      });

    if (type === "content")
      setContentState({
        ...contentState,
        images,
      });
  };

  const appendArtFiles = (fd) => {
    if (artState.portada.images.length)
      fd.append("portada", artState.portada.images[0]);
    if (artState.screen1.images.length)
      fd.append("screen1", artState.screen1.images[0]);
    if (artState.screen2.images.length)
      fd.append("screen2", artState.screen2.images[0]);
    if (artState.screen3.images.length)
      fd.append("screen3", artState.screen3.images[0]);
  };

  const postForm = async (fd) => {
    const res = await fetch(
      `${GENERAL_URL_API}/libros/subirLibroContenido.php`,
      {
        method: "POST",
        credentials: "include",
        body: fd,
      }
    );
    return res.json();
  };

  const uploadContentInChunks = async (contentFile) => {
    const totalChunks = Math.ceil(contentFile.size / CHUNK_SIZE);
    const uploadId = `${book.idLibro}_${Date.now()}_${Math.random()
      .toString(36)
      .slice(2, 10)}`;

    let data = null;

    for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex++) {
      const start = chunkIndex * CHUNK_SIZE;
      const end = Math.min(start + CHUNK_SIZE, contentFile.size);
      const blob = contentFile.slice(start, end);
      const isLastChunk = chunkIndex === totalChunks - 1;

      setUploadProgress({
        current: chunkIndex + 1,
        total: totalChunks,
      });

      const fd = new FormData();
      fd.append("idLibro", book.idLibro);
      fd.append("chunked", "1");
      fd.append("uploadId", uploadId);
      fd.append("chunkIndex", String(chunkIndex));
      fd.append("totalChunks", String(totalChunks));
      fd.append("fileName", contentFile.name);
      fd.append("chunk", blob, `chunk_${chunkIndex}`);

      // Arte y finalización solo en el último chunk
      if (isLastChunk) {
        appendArtFiles(fd);
      }

      data = await postForm(fd);

      if (!data || data.status !== 1) {
        throw new Error(
          data?.info ||
            `Error subiendo el fragmento ${chunkIndex + 1} de ${totalChunks}`
        );
      }
    }

    return data;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setUploadProgress(null);
    try {
      await sendFiles();
      cancelFn();
    } finally {
      setLoading(false);
      setUploadProgress(null);
    }
  };

  const sendFiles = async () => {
    const contentFile = contentState.images[0];
    const useChunked =
      contentFile && contentFile.size > CHUNK_THRESHOLD;

    try {
      let data;

      if (useChunked) {
        data = await uploadContentInChunks(contentFile);
      } else {
        const fd = new FormData();
        fd.append("idLibro", book.idLibro);
        if (contentFile) fd.append("content", contentFile);
        appendArtFiles(fd);
        data = await postForm(fd);
      }

      if (data.status === 1) {
        await swal({
          title: "Rutas modificadas.",
          text: "Los archivos se modificaron satisfactoriamente!",
          icon: "success",
        });
      } else {
        await swal({
          title: "Sorry.",
          text:
            data?.info ||
            "No se pudieron cambiar los archivos, comunicate con soporte.",
          icon: "error",
        });
      }
    } catch (error) {
      console.error(error);
      await swal({
        title: "Error de subida.",
        text:
          error?.message ||
          "No se pudieron subir los archivos. Intenta de nuevo o contacta soporte.",
        icon: "error",
      });
    }
  };

  return (
    <>
      <label className="admin-label-text mt-3 d-block">
        Identificador Makina
      </label>
      <TextField
        variant="outlined"
        size="small"
        disabled
        value={book.idLibro}
        style={{
          width: "100%",
          fontFamily: "'Noto Sans JP', sans-serif",
        }}
      />
      {/* ---------------------------ART files--------------------------- */}
      <label className="admin-label-text mt-3 d-block">Archivos de arte</label>
      <div
        className="admin-muted-text-small"
        style={artState.portada.error ? { color: "red" } : { color: "auto" }}
      >
        Portada*
      </div>
      <DropzoneArea
        id="dropzone"
        dropzoneText="Arrastra un archivo o haz click aquí!"
        showFileNames={true}
        // maxFileSize={3000000} //n in bytes
        showAlerts={true}
        filesLimit={1}
        acceptedFiles={[
          "image/*, application/zip, application/rar,	application/vnd.rar",
        ]}
        onChange={(files) => handleDropFileChange(files, "art", "portada")}
      />

      <div
        className="admin-muted-text-small"
        style={artState.screen1.error ? { color: "red" } : null}
      >
        Screen 1
      </div>
      <DropzoneArea
        id="dropzone"
        dropzoneText="Arrastra un archivo o haz click aquí!"
        showFileNames={true}
        // maxFileSize={3000000} //n in bytes
        showAlerts={true}
        filesLimit={1}
        acceptedFiles={[
          "image/*, application/zip, application/rar,	application/vnd.rar",
        ]}
        onChange={(files) => handleDropFileChange(files, "art", "screen1")}
      />

      <div
        className="admin-muted-text-small"
        style={artState.screen2.error ? { color: "red" } : null}
      >
        Screen 2
      </div>
      <DropzoneArea
        id="dropzone"
        dropzoneText="Arrastra un archivo o haz click aquí!"
        showFileNames={true}
        // maxFileSize={3000000} //n in bytes
        showAlerts={true}
        filesLimit={1}
        acceptedFiles={[
          "image/*, application/zip, application/rar,	application/vnd.rar",
        ]}
        onChange={(files) => handleDropFileChange(files, "art", "screen2")}
      />

      <div
        className="admin-muted-text-small"
        style={artState.screen3.error ? { color: "red" } : null}
      >
        Screen 3
      </div>
      <DropzoneArea
        id="dropzone"
        dropzoneText="Arrastra un archivo o haz click aquí!"
        showFileNames={true}
        // maxFileSize={3000000} //n in bytes
        showAlerts={true}
        filesLimit={1}
        acceptedFiles={[
          "image/*, application/zip, application/rar,	application/vnd.rar",
        ]}
        onChange={(files) => handleDropFileChange(files, "art", "screen3")}
      />
      {/* ---------------------------content files--------------------------- */}
      <label className="admin-label-text mt-3 d-block">
        Archivo de contenido
      </label>
      <div
        className="admin-muted-text-small"
        style={contentState.error ? { color: "red" } : null}
      >
        1 Archivo requerido ["content.epub" o "content.zip" o "content.pdf"] No
        file chosen
      </div>
      <DropzoneArea
        id="dropzone"
        dropzoneText="Arrastra un archivo o haz click aquí!"
        showFileNames={true}
        maxFileSize={5000000000} //n in bytes
        showAlerts={true}
        filesLimit={1}
        acceptedFiles={[
          "application/*, application/x-zip-compressed,application/epub+zip, application/pdf, application/zip, application/rar, application/vnd.rar",
        ]}
        onChange={(files) => {
          handleDropFileChange(files, "content");
        }}
      />

      {uploadProgress && (
        <div className="admin-muted-text-small mt-2">
          Subiendo contenido: fragmento {uploadProgress.current} de{" "}
          {uploadProgress.total}
        </div>
      )}

      <div className="mt-3 w-100 d-flex justify-content-end">
        <Button
          type="submit"
          variant="contained"
          color="primary"
          startIcon={<CheckRounded />}
          style={{ background: "#81c868" }}
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading
            ? uploadProgress
              ? `Subiendo ${uploadProgress.current}/${uploadProgress.total}`
              : "Subiendo..."
            : "Editar"}
        </Button>
        <Button
          variant="contained"
          color="primary"
          className="ml-2"
          startIcon={<CloseRounded style={{ fontSize: "25px" }} />}
          style={{ background: "#f05050" }}
          onClick={cancelFn}
          disabled={loading}
        >
          Cancelar
        </Button>
      </div>
    </>
  );
};

export default EditarArchivosLibro;
